const Series = () => {
    return (
        <div>
            <span className="pageTitle">TV Series</span>
        </div>
    )
}

export default Series
